<template>
  <div class="iframe-container" id="iframe-container">
    <iframe v-if="!novoLayout" title="Dashboard" :src="getLink" frameborder="0" allowFullScreen="true"></iframe>
    <div v-if="novoLayout" ref="reportWrapper" style="width:100%; height:100%; overflow:hidden; position:relative;">
      <div ref="reportContainer" style="position:absolute; top:0px; left:0; width:100%; height:calc(100% + 30px); transform:scale(0.9);
      transform-origin: top left; width:111%; height:111%; border:none;"></div>
    </div>
    <div class="loader" v-if="loader"></div>
    <span v-if="loader" class="carregando">{{ $t('Carregando') }}...</span>
  </div>
</template>

<script>
/* eslint-disable */
export default {
  name: 'ReportViewer',
  props: {
    aba: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      novoLayout: false,
      isAmbev: false,
      loader: false,
      nameEmpresa: '',
      empresasAntigo: []
    }
  },
  computed: {
    getLink() {
      const nomeEmpresa = this.$store.getters['busca/filial']

      let nome_empresa_link = nomeEmpresa.empresa

      if (['MERCOSUL_PX'].some(palavra => nome_empresa_link.includes(palavra))) {
        return 'https://app.powerbi.com/view?r=' + this.aba.lk_link
      }

      if (nome_empresa_link.includes('GINFO')
        || nome_empresa_link.includes('GINFO_EUROPA')
        || nome_empresa_link.includes('AB-INBEV')
        || nome_empresa_link.includes('ZONE')
        || nome_empresa_link.includes('MERCOSUL')
        || nome_empresa_link.includes('GINFO_TSV')
        || nome_empresa_link.includes('BELGIUM')
        || nome_empresa_link.includes('GERMANY')
        || nome_empresa_link.includes('AMBEV')) {
        nome_empresa_link = ''
      } else {
        nome_empresa_link = '&filter=Acessos/ds_empresa%20eq%20%27' + nome_empresa_link + '%27'
      }

      let empresa = '&navContentPaneEnabled=false&filterPaneEnabled=false' + nome_empresa_link

      return 'https://app.powerbi.com/reportEmbed?reportId=' + this.aba.lk_link + empresa + "&filter=Parametro_Idioma/iso%20eq%20%27en%27"
    }
  },
  created() {
    const empresa_json = localStorage.getItem('empresa')
    const empresa = JSON.parse(empresa_json)

    if (this.empresasAntigo.includes(empresa.label)) {
      this.novoLayout = false
    } else {
      this.novoLayout = true
    }

    if (empresa.label == 'AMBEV'
      || empresa.label == 'GINFO'
      || empresa.label == 'DEMARCO'
      || empresa.label == 'MERCOSUL'
      || empresa.label == 'GINFO_IRMAOSANGELO'
      || empresa.label == 'GINFO_TSV'
      || empresa.label == 'AB-INBEV'
      || empresa.label == 'ZONE'
      || empresa.label == 'GINFO_EUROPA'
      || empresa.label == 'BELGIUM'
      || empresa.label == 'GERMANY') {
      this.isAmbev = true
      this.nameEmpresa = empresa.label
    }
  },
  mounted() {
    this.initPowerBI()
  },
  methods: {
    async initPowerBI () {
      if (this.novoLayout === false) {
        return false;
      }

      const str_link = this.aba.lk_link;
      const antesDoE = str_link.split("&")[0];

      const data = { link: antesDoE };

      try {
        const response = await this.$store.dispatch('busca/getEmbedded', data);
        const dados = response;
        this.loader = true

        const models = window['powerbi-client'].models;

        const config = {
          type: 'report',
          id: dados.reportId,
          embedUrl: dados.embedUrl,
          accessToken: dados.embedToken,
          tokenType: models.TokenType.Embed,
          permissions: models.Permissions.All,
          settings: {
            panes: {
              filters: { visible: false },
              pageNavigation: { visible: false }
            },
            bars: {
              statusBar: { visible: false },
              actionBar: { visible: false }
            }
          }
        };

        const container = this.$refs.reportContainer
        container.style.visibility = "hidden";

        const report = powerbi.load(container, config);

        const filiaisArray = Object.values(dados.filiais_liberadas);
        const empresa_json = localStorage.getItem('empresa');
        const empresa = JSON.parse(empresa_json);
        let cdd_relatos = ''
        if (dados.cdd_relatos != null) {
          cdd_relatos = Object.values(dados.cdd_relatos)
        }

        let filtroTable = '';
        let filtroColumn = '';
        let filtroFiliais = [];

        const link_relatos = dados.filtros.ds_link

        if (dados.nome_base == "ginfo_irmaosangelo"
          || dados.nome_base == "ginfo_mercosul") {
          this.isAmbev = true
        }

        if (this.isAmbev) {
          filtroTable = dados.filtros.ds_table;
          filtroColumn = dados.filtros.ds_column;
          filtroFiliais = filiaisArray;
        } else {
          filtroTable = 'Acessos';
          filtroColumn = 'ds_empresa';
          filtroFiliais = [empresa.label];
        }

        // if (this.nameEmpresa == 'GINFO_EUROPA' || this.nameEmpresa == 'AB-INBEV') {
        //   let paisSelecionado = localStorage.getItem('paisSelecionado');

        //   if (paisSelecionado !== null) {
        //     filtroTable = 'Acessos';
        //     filtroColumn = 'ds_empresa';
        //     filtroFiliais = [paisSelecionado];
        //   } else {
        //     filtroTable = 'Acessos';
        //     filtroColumn = 'ds_empresa';
        //     filtroFiliais = ['BELGIUM', 'GERMANY', 'NETHERLENDS'];
        //   }
        // }

        if (link_relatos.includes('RELATOS')) {
          filtroTable = dados.filtros.ds_table;
          filtroColumn = dados.filtros.ds_column;
          filtroFiliais = cdd_relatos;
        }

        const filter = {
          $schema: "http://powerbi.com/product/schema#basic",
          target: {
            table: filtroTable,
            column: filtroColumn
          },
          operator: "In",
          values: filtroFiliais
        };

        let filtroProjetos = ''
        let validaFiltroProjeto = false

        const projetosArray = Object.values(dados.filtro_projetos)

        if (dados.filtros.ds_table_projeto != null) {
          validaFiltroProjeto = true
          filtroProjetos = {
            $schema: "http://powerbi.com/product/schema#basic",
            target: {
              table: dados.filtros.ds_table_projeto,
              column: dados.filtros.ds_column_projeto
            },
            operator: "In",
            values: projetosArray
          };
        }

        report.on("loaded", async () => {
          try {
            console.log("Relatório carregado, aplicando filtro antes do render...");
            if (validaFiltroProjeto == true) {
              await report.setFilters([filter, filtroProjetos]);
            } else {
              await report.setFilters([filter]);
            }

            console.log("Filtro aplicado, renderizando relatório...");
            await report.render();
            this.loader = false
            container.style.visibility = "visible";
            console.log("Relatório renderizado e visível.");
          } catch (err) {
            console.error("Erro ao aplicar filtro antes do render:", err);
            container.style.visibility = "visible";
          }
        });
      } catch (error) { s
        console.error("Erro ao carregar embed:", error);
      }
    }
  }
}
</script>

<style scoped>
.iframe-container {
  position: relative;
  overflow: hidden;
  border-radius: 8px;
  width: 100%;
  height: 100%;
}

.iframe-container iframe {
  width: 100%;
  height: 100%;
  border: none;
}

.loader {
  position: fixed;
  left: 48%;
  top: 50%;
  width: 50px;
  padding: 8px;
  aspect-ratio: 1;
  border-radius: 50%;
  background: #eeeeee;
  --_m:
    conic-gradient(#0000 10%, #000),
    linear-gradient(#000 0 0) content-box;
  -webkit-mask: var(--_m);
  mask: var(--_m);
  -webkit-mask-composite: source-out;
  mask-composite: subtract;
  animation: l3 1s infinite linear;
}

@keyframes l3 {
  to {
    transform: rotate(1turn)
  }
}

.carregando {
  position: fixed;
  left: 45%;
  top: 58%;
  font-size: 24px;
  color: #eee;
}
</style>
